import keyBy from "lodash/keyBy";

/**
 * Convert from squared-meters to acres. Note that we're not suffixing with
 * "ac" or "ha" here. That's for `react-intl` to add via a `<FormattedMessage>`
 *
 * @deprecated Please use the `@granular/ag-uom` package instead.
 */
export const convertSquareMetresToAcres = (
  areaInSquareMetres: number,
): number => {
  return Math.round(areaInSquareMetres * 0.000247105 * 100) / 100;
};

/**
 * Convert from squared-meters to hectares. Note that we're not suffixing with
 * "ac" or "ha" here. That's for `react-intl` to add via a `<FormattedMessage>`
 *
 * @deprecated Please use the `@granular/ag-uom` package instead.
 */
export const convertSquareMetresToHectares = (
  areaInSquareMetres: number,
): number => {
  return Math.round(areaInSquareMetres * 0.0001 * 100) / 100;
};

/**
 * Expected that any GeoJSON conversion functions will live here. Split
 * this module out if it gets 'big'. Use wisdom and hence judgement to
 * know what 'big' means.
 */

/**
 * Derived data computations
 *
 * TODO: These need to go away. We should not require them because we shouldn't
 * be performing data gymnastics in the customer's browser (especially with
 * large objects.) Upstream should give us the data we want in the shape we
 * want it in.
 */

export const convertDataToDataById = <T extends { id: string | number }>(
  data: readonly T[],
): Record<string, T | undefined> => {
  return keyBy(data, "id");
};

export const convertDataToDataByGranularId = <
  T extends { granularId: string | number },
>(
  data: readonly T[],
): Record<string, T | undefined> => {
  return keyBy(data, "granularId");
};
